import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory"
import { ConsultaRemessa } from "./consulta-remessa"
import { ConsultaRemessaProvider } from "./context/consulta-remessa-context"

export const ConsultaRemessaFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle="Consulta Remessa">
            <ConsultaRemessaProvider>
                <ConsultaRemessa />
            </ConsultaRemessaProvider>
        </BaseInternalFormFactory>
    )
}